<template>
  <div>
    <div class="flex flex-wrap-reverse items-center">
      <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push({name: 'importation-description-new'}).catch((err) => {})">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Novo</span>
      </div>
    </div>
    <vs-table
      ref="table"
      :max-items="1000"
      :noDataText="'Nenhuma descrição encontrada'"
      :data="descriptions">

      <template slot="thead">
        <vs-th sort-key="sigla">Sigla</vs-th>
        <vs-th sort-key="descricao">Descrição</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="descriptions" :key="indextr" v-for="(description, indextr) in data">
            <vs-td>
              <p class="font-medium truncate">{{ description.sigla }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">{{ description.descricao }}</p>
            </vs-td>
            <vs-td>
              <feather-icon
                icon="EditIcon"
                svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" 
                @click="editDescription(description.sigla)"/>
              <feather-icon
                icon="Trash2Icon"
                svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer"
                @click="deleteDescriptionDialog(description.sigla)" />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>
<script>
import axios from 'axios'
import { baseApiUrl } from "@/global"

export default {
  data() {
    return {
      descriptions: [],
      initial: undefined,
    }
  },
  methods: {
    async loadDescriptions() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/descriptions`);
        this.descriptions = response.data
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar" + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    editDescription(initial){
      this.$router.push({ path: `/importacoes/descricoes/editar/${initial}`})
    },
    deleteDescriptionDialog(initial) {
      this.initial = initial
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Excluir`,
        text: `Você tem certeza que excluir a sigla "${initial}"?`,
        accept: this.deleteDescription,
        acceptText: "Excluir",
        cancelText: "Cancelar"
      })
    },
    async deleteDescription() {
      try {
        this.$vs.loading();
        const initial = this.initial
        await axios.delete(`${baseApiUrl}/descriptions/${initial}`);
        this.$vs.notify({
          color: 'success',
          title: 'Excluido',
          text: `Descrição excluida com successo.`
        })
        this.descriptions = this.descriptions.filter(el => el.sigla != initial)
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel excluir: " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    await this.loadDescriptions()
  }
}

</script>
